import React from 'react';
import {
  Dimmer,
  Loader,
} from 'semantic-ui-react';

const LoadingView = (props) => (
  <Dimmer active inverted>
    <Loader
      content="Loading..."
      size="massive"
    />
  </Dimmer>
);

export default LoadingView;
